import React from 'react';
import MainLayout from '../layout/MainLayout';
import PrivacyPolicy from '../components/PrivacyPolicy';

const PrivacyPolicyPage = () => {
  return (
    <MainLayout>
        <PrivacyPolicy/>
    </MainLayout>
  )
}

export default PrivacyPolicyPage